import { DatePicker } from 'antd';
import { Moment } from 'moment';

import * as S from './styles';

type RangeValue = [Moment | null, Moment | null] | null;

interface Props {
  value?: RangeValue;
  onChange?: (value: RangeValue) => void;
  placeholder?: [string, string];
  format?: string;
}

export default function SplitDateRangePicker({
  value,
  onChange,
  placeholder = ['De', 'Até'],
  format = 'DD/MM/YYYY',
}: Props) {
  const [start, end] = value ?? [null, null];

  const emit = (nextStart: Moment | null, nextEnd: Moment | null) =>
    onChange?.(nextStart && nextEnd ? [nextStart, nextEnd] : null);

  const changeStart = (nextStart: Moment | null) => {
    const keepsEnd = end && nextStart && !nextStart.isAfter(end, 'day');
    emit(nextStart, keepsEnd ? end : nextStart);
  };

  const changeEnd = (nextEnd: Moment | null) => emit(start ?? nextEnd, nextEnd);

  return (
    <S.Fields>
      <DatePicker
        aria-label={placeholder[0]}
        value={start}
        onChange={changeStart}
        placeholder={placeholder[0]}
        format={format}
        inputReadOnly
      />
      <DatePicker
        aria-label={placeholder[1]}
        value={end}
        onChange={changeEnd}
        disabledDate={(day) => Boolean(start && day.isBefore(start, 'day'))}
        placeholder={placeholder[1]}
        format={format}
        inputReadOnly
      />
    </S.Fields>
  );
}
